import { purchasePaymentUrl } from '../../../constants/urls';
import { columns } from '../../../constants/grid/PagoCompra';
import { formatCurrency } from '../../../utils/currency';
import { formatDate } from '../../../utils/date';
import GenericList from '../../../components/List';

const mapPaymentData = (data) => {
  return data.map((p) => ({
    id: p.id,
    paymentDate: formatDate(p.fecha_pago),
    supplier: p.compra?.proveedor || '-',
    buyDate: p.compra?.fecha ? formatDate(p.compra.fecha) : '-',
    amount: formatCurrency(p.importe_abonado),
    paymentType: p.tipo_pago?.descripcion || '-',
    cheque: p.cheque?.numero || p.cheque_propio?.numero || '-',
    chequeRechazado: p.cheque?.estado === 'RECHAZADO',
  }));
};

const data = {
  title: 'Pagos de Compras',
  fetchUrl: {
    baseUrl: purchasePaymentUrl,
    createUrl: '/purchase-payment/create',
    detailUrl: '/purchase-payment/detail',
  },
  columns,
  mapData: mapPaymentData,
  newLabelText: 'Nuevo pago',
  multiSelect: false,
  showEdit: false,
};

const PurchasePaymentList = () => <GenericList data={data} />;

export default PurchasePaymentList;
